export function isDefined(value: any): boolean {
    return typeof value !== 'undefined' && value !== null;
  }
  